import { combineEpics } from 'redux-observable';

import { _reducer } from './SchoolSettings.reducers';
import _epics from './SchoolSettings.epics';

export const epics = combineEpics(_epics);
export { _reducer };
export * from './SchoolSettings.actions';
